/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalAnswerItemDataSchema = z.object({
	questionId: z.string().uuid(),
	answer: z.string().nullable(),
	optionId: z.string().uuid().nullable(),
})

export type AdditionalAnswerItemDataSchema = z.infer<typeof additionalAnswerItemDataSchema>
